import "../styles/interests.css";

import heroBg    from "../photos/interests.jpg";
import softIc    from "../photos/interests_softic.jpg";
import dataSci   from "../photos/interests_datasci.png";
import mic       from "../photos/interests_mic.png";
import webDes    from "../photos/interests_webdes.png";
import webDev    from "../photos/interests_webdev.png";
import frontBack from "../photos/interests_front&back.png";

const ROW1 = [
  { id: "softic",  img: softIc,  label: "Software IC Design", sub: "RTL · VLSI · HDL",               pos: "p1" },
  { id: "datasci", img: dataSci, label: "Data Science",        sub: "ML · Analytics · Python",        pos: "p2" },
  { id: "mic",     img: mic,     label: "Microelectronics",    sub: "Analog · Mixed-Signal · CMOS",   pos: "p3" },
];

const ROW2 = [
  { id: "webdes",    img: webDes,    label: "Web Designing",     sub: "UI · UX · Visual Systems",   pos: "p1" },
  { id: "webdev",    img: webDev,    label: "Web Developing",    sub: "React · Node · APIs",         pos: "p2" },
  { id: "frontback", img: frontBack, label: "Frontend & Backend",sub: "Full-Stack · Cloud · Auth",   pos: "p3" },
];

function Panel({ item }) {
  return (
    <div className={`int-panel int-panel--${item.pos}`}>
      <img src={item.img} alt={item.label} className="int-panel__img" />
      <div className="int-panel__overlay" />
      <div className="int-panel__text">
        <p className="int-panel__sub">{item.sub}</p>
        <p className="int-panel__label">{item.label}</p>
      </div>
      <div className="int-panel__accent" />
      <div className="int-panel__sep" />
    </div>
  );
}

export default function Interests() {
  return (
    <div className="int-page">
      {/* ── Hero ── */}
      <div className="int-hero">
        <img src={heroBg} alt="" className="int-hero__bg" aria-hidden="true" />
        <div className="int-hero__overlay" />
        <div className="int-hero__content">
          <p className="int-hero__eyebrow">What drives me</p>
          <h1 className="int-hero__title">Interests & Passions</h1>
          <p className="int-hero__desc">
            A snapshot of the fields I explore — from silicon to software.
          </p>
        </div>
      </div>

      {/* ── Rule ── */}
      <div className="int-hero-rule" />

      {/* ── Grid ── */}
      <div className="int-grid">
        <div className="int-row">
          {ROW1.map((item) => <Panel key={item.id} item={item} />)}
        </div>
        <div className="int-row">
          {ROW2.map((item) => <Panel key={item.id} item={item} />)}
        </div>
      </div>
    </div>
  );
}